<div class="inicio">
  <div class="div" >
    <p class="titulo">VISUALIZAR USUARIOS
      <mat-icon color="primary" matTooltip="Click para más información" (click)="botonInformacion()" >info</mat-icon>

      <!--<button mat-mini-fab style="background-color: #161aff;" matTooltip="Podrá visualizar todos los servicios dados de alta, activados o suspendidos de todos los colaboradores" > <span class="material-icons">info</span> </button>-->
    </p>
    <mat-tab-group (selectedIndexChange)="llenarTablaTodos()"  ><!--(selectedIndexChange)="seleccionarTabla($event)"-->

      <!-- SERVICIOS DE USUARIO DADOS DE ALTA -->
      <mat-tab label="ALTA" >
        <mat-progress-bar style="width: 100%;" *ngIf="expression ||expression2 ||expression3" [color]="color" [mode]="mode"></mat-progress-bar>
        <div class="div">
          <!--Barra de búsqueda-->
          <div class="grid-container2">
            <div class="div" class="grid-container" >
              <mat-form-field>
                <mat-label>BUSCAR</mat-label>
                <input matInput (keyup)="applyFilterAl($event) "  placeholder="INGRESE DATO A BUSCAR">
              </mat-form-field>
            </div>

          </div>

          <!--Boton Descargar reporte--
            <div class="grid-container5">
              <button mat-raised-button color="primary"> REPORTE
                  <mat-icon> file_download </mat-icon>
              </button>&nbsp;
            </div> -->
          <table mat-table [dataSource] = "dataSourceAl"  >
              <ng-container matColumnDef="nomColaborador">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                  <td mat-cell *matCellDef="let element"> {{element.nomColaborador}} </td>
              </ng-container>
              <ng-container matColumnDef="nomPuesto">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>PUESTO DEL EMPLEADO </th>
                <td mat-cell *matCellDef="let element"> {{element.nomPuesto}} </td>
              </ng-container>
              <ng-container matColumnDef="nombre_servicio">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                  <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
              </ng-container>
              <ng-container matColumnDef="status_serv">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS DEL REGISTRO </th>
                <td mat-cell *matCellDef="let element"> {{element.status_serv}} </td>
              </ng-container>
              <ng-container matColumnDef="fechaRegistro">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE REGISTRO </th>
                  <td mat-cell *matCellDef="let element"> {{element.fechaRegistro?.substring(0,10)}} </td>
              </ng-container>
              <ng-container matColumnDef="fecha_mod_reg">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ÚLTIMA MODIFICACIÓN</th>
                <td mat-cell *matCellDef="let element"> {{element.fecha_mod_reg ?.substring(0,10)}} </td>
              </ng-container>
              <ng-container matColumnDef="usuario">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                <td mat-cell *matCellDef="let element"> {{element.usuario}} </td>
            </ng-container>
            <ng-container matColumnDef="pass">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> CONTRASEÑA</th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field appearance="outline">
                  <mat-label>Contraseña</mat-label>
                  <input matInput [type]="element.pass ? 'password' : 'text'" value="{{element.contrasenia}}" readonly>
                  <button mat-icon-button matSuffix (click)="element.pass = !element.pass" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" >
                    <mat-icon>{{element.pass ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                </mat-form-field>
              </td>
            </ng-container>
              <tr mat-header-row *matHeaderRowDef="encabezadostablaAlta"></tr>
              <tr mat-row *matRowDef="let row; columns: encabezadostablaAlta;"></tr>

          </table>
          <mat-paginator #paginatorAl [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>

        </div>
      </mat-tab>

      <!-- SERVICIOS DE USUARIO ACTIVOS -->
      <mat-tab label="ACTIVADOS" [disabled]="expression " >
        <div class="div">
          <!--Barra de búsqueda-->
          <div class="grid-container2">
            <div class="div" class="grid-container" >
              <mat-form-field>
                <mat-label>BUSCAR</mat-label>
                <input matInput  (keyup)="applyFilterAc($event) "  placeholder="INGRESE DATO A BUSCAR">
              </mat-form-field>
            </div>
          </div>

          <!--Boton Descargar reporte--
          <div class="grid-container5">
              <button mat-raised-button color="primary"> REPORTE
                  <mat-icon> file_download </mat-icon>
              </button>&nbsp;
          </div>  -->
          <table mat-table [dataSource] = "dataSourceAc"   >
              <ng-container matColumnDef="nomColaborador">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                  <td mat-cell *matCellDef="let element"> {{element.nomColaborador}} </td>
              </ng-container>
              <ng-container matColumnDef="nomPuesto">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>PUESTO A CUBRIR </th>
                <td mat-cell *matCellDef="let element"> {{element.nomPuesto}} </td>
              </ng-container>
              <ng-container matColumnDef="nomSucursalCol">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL A CUBRIR </th>
                <td mat-cell *matCellDef="let element"> {{element.nomSucursalCol}} </td>
              </ng-container>
              <ng-container matColumnDef="nombre_servicio">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                  <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
              </ng-container>
              <ng-container matColumnDef="status_serv">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS DEL REGISTRO </th>
                <td mat-cell *matCellDef="let element"> {{element.status_serv}} </td>
              </ng-container>
              <ng-container matColumnDef="fechaRegistro">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE REGISTRO </th>
                  <td mat-cell *matCellDef="let element"> {{element.fechaRegistro?.substring(0,10)}} </td>
              </ng-container>
              <ng-container matColumnDef="fecha_mod_reg">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ÚLTIMA MODIFICACIÓN</th>
                <td mat-cell *matCellDef="let element"> {{element.fecha_mod_reg?.substring(0,10)}} </td>
              </ng-container>
              <ng-container matColumnDef="usuario">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO</th>
                <td mat-cell *matCellDef="let element"> {{element.usuario}} </td>
            </ng-container>
            <ng-container matColumnDef="pass">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> CONTRASEÑA</th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field appearance="outline">
                  <mat-label>Contraseña</mat-label>
                  <input matInput [type]="element.pass ? 'password' : 'text'" value="{{element.contrasenia}}" readonly>
                  <button mat-icon-button matSuffix (click)="element.pass = !element.pass" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" >
                    <mat-icon>{{element.pass ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                </mat-form-field>
              </td>
            </ng-container>
              <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
              <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

          </table>
          <mat-paginator #paginatorAc [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>

        </div>
      </mat-tab>

      <!-- SERVICIOS DE USUARIO SUSPENDIDOS  -->
      <mat-tab label="SUSPENDIDOS" [disabled]="expression ||expression2 " >
        <div class="div">
          <!--Barra de búsqueda-->
          <div class="grid-container2">
            <div class="div" class="grid-container" >
              <mat-form-field>
                <mat-label>BUSCAR</mat-label>
                <input matInput  (keyup)="applyFilterS($event) "  placeholder="INGRESE DATO A BUSCAR">
              </mat-form-field>
            </div>
          </div>

          <table mat-table [dataSource] = "dataSourceS"   >
              <ng-container matColumnDef="nomColaborador">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                  <td mat-cell *matCellDef="let element"> {{element.nomColaborador}} </td>
              </ng-container>
              <ng-container matColumnDef="nomPuesto">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>PUESTO A CUBRIR </th>
                <td mat-cell *matCellDef="let element"> {{element.nomPuesto}} </td>
              </ng-container>
              <ng-container matColumnDef="nomSucursalCol">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL A CUBRIR </th>
                <td mat-cell *matCellDef="let element"> {{element.nomSucursalCol}} </td>
              </ng-container>
              <ng-container matColumnDef="nombre_servicio">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                  <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
              </ng-container>
              <ng-container matColumnDef="status_serv">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS DEL REGISTRO </th>
                <td mat-cell *matCellDef="let element"> {{element.status_serv}} </td>
              </ng-container>
              <ng-container matColumnDef="fechaRegistro">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE REGISTRO </th>
                  <td mat-cell *matCellDef="let element"> {{element.fechaRegistro?.substring(0,10)}} </td>
              </ng-container>
              <ng-container matColumnDef="fecha_mod_reg">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ÚLTIMA MODIFICACIÓN</th>
                <td mat-cell *matCellDef="let element"> {{element.fecha_mod_reg?.substring(0,10)}} </td>
              </ng-container>
              <ng-container matColumnDef="usuario">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                <td mat-cell *matCellDef="let element"> {{element.usuario}} </td>
            </ng-container>
            <ng-container matColumnDef="pass">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> CONTRASEÑA</th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field appearance="outline">
                  <mat-label>Contraseña</mat-label>
                  <input matInput [type]="element.pass ? 'password' : 'text'" value="{{element.contrasenia}}" readonly>
                  <button mat-icon-button matSuffix (click)="element.pass = !element.pass" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" >
                    <mat-icon>{{element.pass ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                </mat-form-field>
              </td>
            </ng-container>
              <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
              <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

          </table>
          <mat-paginator #paginatorS [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>

        </div>
      </mat-tab>

      <!-- TODOS LOS SERVICIOS DE USUARIO  -->
      <mat-tab label="TODOS" [disabled]="expression ||expression2 ||expression3" >
        <div class="div">
          <!--Barra de búsqueda-->
          <div class="grid-container2">
            <div class="div" class="grid-container" >
              <mat-form-field>
                <mat-label>BUSCAR</mat-label>
                <input matInput  (keyup)="applyFilterT($event) "  placeholder="INGRESE DATO A BUSCAR">
              </mat-form-field>
            </div>
          </div>

          <!--Boton Descargar reporte--
          <div class="grid-container5">
              <button mat-raised-button color="primary"> REPORTE
                  <mat-icon> file_download </mat-icon>
              </button>&nbsp;
          </div> -->
          <table mat-table [dataSource] = "dataSourceT"   >
              <ng-container matColumnDef="nomColaborador">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                  <td mat-cell *matCellDef="let element"> {{element.nomColaborador}} </td>
              </ng-container>
              <ng-container matColumnDef="nomPuesto">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> PUESTO </th>
                <td mat-cell *matCellDef="let element"> {{element.nomPuesto}} </td>
              </ng-container>
              <ng-container matColumnDef="nomSucursalCol">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL A CUBRIR </th>
                <td mat-cell *matCellDef="let element"> {{element.nomSucursalCol}} </td>
              </ng-container>
              <ng-container matColumnDef="nombre_servicio">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                  <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
              </ng-container>
              <ng-container matColumnDef="status_serv">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS DEL REGISTRO </th>
                <td mat-cell *matCellDef="let element"> {{element.status_serv}} </td>
              </ng-container>
              <ng-container matColumnDef="fechaRegistro">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE REGISTRO </th>
                  <td mat-cell *matCellDef="let element"> {{element.fechaRegistro?.substring(0,10)}} </td>
              </ng-container>
              <ng-container matColumnDef="fecha_mod_reg">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ÚLTIMA MODIFICACIÓN</th>
                <td mat-cell *matCellDef="let element"> {{element.fecha_mod_reg?.substring(0,10)}} </td>
              </ng-container>
              <ng-container matColumnDef="usuario">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                <td mat-cell *matCellDef="let element"> {{element.usuario}} </td>
            </ng-container>
            <ng-container matColumnDef="pass">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> CONTRASEÑA</th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field appearance="outline">
                  <mat-label>Contraseña</mat-label>
                  <input matInput [type]="element.pass ? 'password' : 'text'" value="{{element.contrasenia}}" readonly>
                  <button mat-icon-button matSuffix (click)="element.pass = !element.pass" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" >
                    <mat-icon>{{element.pass ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                </mat-form-field>
              </td>
            </ng-container>

              <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
              <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

          </table>
          <mat-paginator #paginatorT [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>

</div>
